export const en = {
  BALANCE_DISPENSE: 'dispense',
  BALANCE_PLACEHOLDER: 'CUSTOM AMOUNT',
  BALANCE_DEPOSIT: 'deposit',
  BALANCE_TITLE: 'Balance',
  ARTICLE_HEADLINE: 'Articles',
  ARTICLE_LINK: 'Article List',
  ARTICLE_ADD_LINK: 'add new articles',
  ARTICLE_ADD_FORM_NAME_LABEL: 'Name:',
  ARTICLE_ADD_FORM_BARCODE_LABEL: 'Barcode:',
  ARTICLE_ADD_FORM_AMOUNT_LABEL: 'Price:',
  ARTICLE_LOADING_BY_BARCODE: 'fetching article by barcode',
  ARTICLE_FETCHED_BY_BARCODE: 'you just scanned:',
  ARTICLES_COULD_NOT_BE_LOADED:
    'Could not load Articles maybe check your internet connection',
  ARTICLE_COULD_NOT_BE_CREATED:
    'Could not create the article maybe check your internet connection',
  ARTICLE_COULD_NOT_BE_LOADED_BY_BARCODE:
    'Could not load the article by barcode',
  TALLY_HEADER: 'Strichliste',
  USERS_LOADING_FAILED:
    'Oops could not load users :-( Maybe check your internet connection and try it again',
  USERS_CREATION_FAILED: 'Oops could not create this user',
  USERS_CREATION_FAILED_USER_EXIST: 'This user already exists',
  USER_EDIT_TOKEN_IN_USE: 'This token is already in use by another user',
  USER_EDIT_USER_FAILED:
    'Could not save the user :-(. Check your input or your internet connection',
  USER_SEARCH_LINK: 'Find users',
  USER_ARTICLE_LINK: 'Buy article',
  USER_SEARCH_HEADLINE: 'Find users',
  USER_ACTIVE: 'Active users',
  USER_INACTIVE: 'Inactive users',
  USER_ACTIVE_LINK: 'active users',
  USER_INACTIVE_LINK: 'inactive users',
  USER_TRANSACTIONS: 'Transactions',
  USER_TRANSACTIONS_LINK: 'ALL TRANSACTIONS',
  USER_TRANSACTIONS_LOADING_ERROR: 'Could not load transactions',
  USER_TRANSACTION_CREATION_ERROR: 'Could not create transaction',
  USER_TRANSACTION_DELETION_ERROR: 'Could not undo transaction',
  USER_TRANSACTIONS_SENDER: 'sender',
  USER_TRANSACTIONS_TABLE_ARTICLE: 'article',
  USER_TRANSACTIONS_TABLE_SENDER: 'sender',
  USER_TRANSACTIONS_TABLE_RECIPIENT: 'recipient',
  USER_TRANSACTIONS_TABLE_COMMENT: 'comment',
  USER_TRANSACTIONS_TABLE_AMOUNT: 'amount',
  USER_TRANSACTIONS_TABLE_CREATED: 'created',
  USER_TRANSACTIONS_TABLE_LOAD_NEXT_ROWS: 'more',
  USER_TRANSACTIONS_RECIPIENT: 'recipient',
  USER_TRANSACTION_CREATE: 'Send money to a friend',
  USER_TRANSACTION_CREATE_SUBMIT_TITLE:
    'Submit to send this amount to a friend',
  USER_TRANSACTION_CREATE_LINK: 'Send money',
  USER_TRANSACTION_CREATE_CUSTOM_HEADLINE: 'Custom transaction',
  USER_TRANSACTION_CREATE_CUSTOM_DEPOSIT_BUTTON: 'Charge wallet',
  USER_TRANSACTION_CREATE_CUSTOM_DISPENSE_BUTTON: 'Pay purchase',
  USER_TRANSACTION_FROM_AMOUNT_LABEL: 'Amount',
  USER_TRANSACTION_UNDO: 'undo',
  USER_SELECTION_LIST_LABEL: 'Select a user by name',
  USER_CREATE_HEADLINE: 'Create new user',
  USER_CREATE_TRIGGER: 'Create user',
  USER_CREATE_NAME_LABEL: 'add new user',
  USER_EDIT_LINK: 'edit user',
  USER_EDIT_HEADLINE: 'Edit user',
  USER_EDIT_TRIGGER: 'save changes',
  USER_EDIT_NAME_LABEL: 'name',
  USER_EDIT_MAIL_LABEL: 'e-mail',
  USER_EDIT_TOKEN_LABEL: 'token',
  USER_EDIT_ACTIVE_LABEL: 'User is inactive',
  USER_EDIT_ACTIVE_WARNING: 'you can not enable a disabled user. So take care',
  PAYMENT_DEPOSIT_LABEL: 'Charge your wallet',
  PAYMENT_DISPENSE_LABEL: 'What you have to pay',
  BACK_BUTTON: 'back',
  SETTINGS_LOADED_FAILED:
    'Could not load settings, falling back to default settings',
  PAGER_PREV: 'prev',
  PAGER_NEXT: 'next',
  SEARCH: 'Search',
  CREATE_USER_TO_USER_TRANSACTION_SUCCESS: 'You sent User',
  CREATE_USER_TO_USER_TRANSACTION_USER: 'Username',
  CREATE_USER_TO_USER_TRANSACTION_COMMENT: 'Add notes to your transaction',
  TRANSACTION_EMPTY_STATE: 'You have no transactions yet :,(',
  METRICS_HEADLINE: 'Metrics',
  ARTICLE_ACTIVE_HEADLINE: 'Active Articles',
  ARTICLE_INACTIVE_HEADLINE: 'Inactive Articles',
  SPLIT_INVOICE_LINK: 'Split Invoice',
  SPLIT_INVOICE_HEADLINE: 'Split Invoice',
  SPLIT_INVOICE_SUBMIT: 'submit the split invoice',
};
